<template>
  <div v-html="strategy"></div>
</template>

<script>
import { getActivityRuleContent } from "@/api/join";
export default {
  data() {
    return {
      strategy: "",
    };
  },
  mounted() {
    getActivityRuleContent({ type: "13" }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.strategy = res.content.content;
      }
    });
  },
};
</script>

<style>
</style>